import type { App } from 'vue'

export interface IChatbot {
  id: string
  tenantId: string
  createdAt: Date
  modifiedAt: Date
  configuration?: IChatbotConfiguration | null
  brand?: IChatbotBrand | null
  defaultQuestions: string[]
}

export interface IChatbotConfiguration {
  deploymentType: DeploymentType
  showSourceAttribution: boolean
  isActive: boolean
  position?: Position
  autoOpen?: boolean
  isAuthRequired?: boolean | null
  webDirectSlug?: string | null
}

export interface IChatbotBrand {
  name: string
  description?: string | null
  brandColor?: string | null
  logoUrl?: string | null
}

export enum DeploymentType {
  _PublicWidget = 'PublicWidget',
  _WebDirect = 'WebDirect',
  _SiddDuo = 'SiddDuo',
  _SiddStudio = 'SiddStudio',
}

export enum Position {
  _BottomRight = 'BottomRight',
  _BottomLeft = 'BottomLeft',
  _TopRight = 'TopRight',
  _TopLeft = 'TopLeft',
  _FillParent = 'FillParent',
}

export enum AccessMode {
  _Public = 'Public',
  _Authenticated = 'Authenticated',
  _Restricted = 'Restricted',
}

export interface IChatbotAppInstance {
  app: App
  element: Element | null
  mount?: (_container: string | Element) => IChatbotAppInstance
  unmount: () => void
  open: () => void
  close: () => void
  toggle: () => void
  sendMessage: (_message: string) => void
  isOpen: () => boolean
  clearHistory: () => void
}

export interface ISiddChatbotGlobal {
  create: (
    _config: Record<string, unknown> & { container?: string | Element }
  ) => IChatbotAppInstance
  get: (_chatbotId: string) => IChatbotAppInstance | null
  destroy: (_chatbotId: string) => boolean
  destroyAll: () => void
  getAllInstances: () => IChatbotAppInstance[]
  version: string
}
